import { Injectable } from '@angular/core';
import { GqlService } from './gql.service';
import {
    SporitelnaGetBankAccountInput,
} from '@libs/types/src/chcrm/input-type/sporitelna/sporitelna-get-bank-account.input';
import {
    SporitelnaBankAccountObject,
} from '@libs/types/src/chcrm/object-type/sporitelna/sporitelna-bank-account.object';
import { sporitelnaBankAccountFrag } from './types/sporitelna.types';

/**
 * @Deprecated()
 */
@Injectable()
export class SporitelnaService extends GqlService {

    getBanks(input: SporitelnaGetBankAccountInput) {
        return this.query<SporitelnaBankAccountObject[]>(`
                query ($input: SporitelnaGetBankAccountInput!) {
                    sporitelna {
                        banks(input: $input) {
                            ${sporitelnaBankAccountFrag}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
